export default __webpack_public_path__ + "fonts/rental-roi-icon.svg";